import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import ruLocale from 'i18n-iso-countries/langs/ru.json';
import ukLocale from 'i18n-iso-countries/langs/uk.json';
import i18next from 'i18next';
import I18NextChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import LocalStorage from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';

import I18nextBrowserLanguageDetectorTWA from './I18nextBrowserLanguageDetectorTWA';
import { i18nextDefaultInitOptions } from './i18nextDefaultInitOptions';

import type { ChainedBackendOptions } from 'i18next-chained-backend';

// Register locales for country names
countries.registerLocale(enLocale);
countries.registerLocale(ruLocale);
countries.registerLocale(ukLocale);

const i18nextLocal = i18next.createInstance();

i18nextLocal
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetectorTWA)
  .use(I18NextChainedBackend)
  .init<ChainedBackendOptions>({
    ...i18nextDefaultInitOptions,
    backend: {
      backendOptions: [
        {
          store: window.localStorage,
        },
        {
          loadPath: '/locale/{{lng}}/{{ns}}.json',
        },
      ],
      backends: [LocalStorage, HttpApi],
    },
    defaultNS: 'translation',
    detection: {
      order: ['twa', 'querystring', 'localStorage', 'navigator'],
    },
    fallbackLng: 'en',
  });

export { i18nextLocal };
